import { cartHasEntriesRule } from './rules/cart-shape.js';
import type { OfflineCartRule } from './types.js';

export const defaultOfflineCartRules: readonly OfflineCartRule[] = [cartHasEntriesRule];
